/* eslint-disable react/no-unknown-property */
import {
  Action,
  ActionImage, FontWeight, Grid, ICON_PLAY_CIRCLE, IframeWrapper, ModalSize, Portal, Text, useModal,
} from '@doveit/bricks';
import React from 'react';
import * as styles from './TutorialView.style';
import SimpleModal from '../simple-modal/SimpleModal';

export interface TutorialViewProps {
  cover: string,
  title: string,
  description: string,
  videoURL: string,
}

const TutorialView: React.FC<TutorialViewProps> = ({
  cover,
  title,
  description,
  videoURL,
}) => {
  const modal = useModal();

  return (
    <>
      <div aria-label="Tutorial">
        <Grid gutter={150}>
          <Grid.Unit size={{ MD: 1 / 2 }}>
            <ActionImage
              imageUri={cover}
              caption={title}
              captionIcon={ICON_PLAY_CIRCLE}
              onClick={() => modal.open()}
            />
          </Grid.Unit>

          <Grid.Unit size={{ MD: 1 / 2 }}>
            <div css={styles.tutorialDescription}>
              <Text.Body fontWeight={FontWeight.MEDIUM}>
                {description}
              </Text.Body>

              <Action
                label="Guarda il video"
                emphasis="high"
                color="primary"
                size="S"
                iconLeft={{ path: ICON_PLAY_CIRCLE }}
                onClick={() => modal.open()}
              />
            </div>
          </Grid.Unit>
        </Grid>
      </div>
      <Portal>
        <SimpleModal
          {...modal}
          size={ModalSize.MEDIUM}
          title={title}
          aria-label="Modale per consultare il tutorial"
        >
          <IframeWrapper
            aria-label={title}
            src={videoURL}
            title={title}
          />
        </SimpleModal>
      </Portal>
    </>
  );
};

export default TutorialView;
